import styled from 'styled-components'

export const ModalContent = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['24'],
  width: '47rem',
}))

export const SectionHeader = styled.div(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '1.8rem',
  fontWeight: 500,
  lineHeight: '2.4rem',
}))

export const SectionHeaderRow = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: theme.space['8'],
}))

export const SectionBody = styled.div(({ theme }) => ({
  border: `${theme.border.size['1']} solid ${theme.colors.gray200}`,
  borderRadius: theme.border.radius['6'],
  display: 'flex',
  flexDirection: 'column',
}))

export const Item = styled.div(({ theme }) => ({
  '&:nth-child(even)': {
    backgroundColor: theme.colors.white,
  },
  '&:nth-child(odd)': {
    backgroundColor: theme.colors.gray200,
  },
  alignItems: 'center',
  color: theme.colors.black600,
  display: 'flex',
  flexDirection: 'row',
  fontSize: '1.4rem',
  fontWeight: 500,
  justifyContent: 'space-between',
  lineHeight: '2rem',
  padding: `${theme.space['8']} ${theme.space['16']}`,
}))

export const ImageRow = styled.div(({ theme }) => ({
  '&:nth-child(even)': {
    backgroundColor: theme.colors.white,
  },
  '&:nth-child(odd)': {
    backgroundColor: theme.colors.gray200,
  },
  color: theme.colors.black500,
  display: 'flex',
  flexDirection: 'column',
  fontSize: '1.4rem',
  fontWeight: 500,
  gap: theme.space['8'],
  padding: `${theme.space['8']} ${theme.space['16']}`,
}))

export const ImageLink = styled.span({
  cursor: 'pointer',
  textDecoration: 'underline',
})
